/**
 * @description 顏色漸層字體
 */
export const gradientStyle = {
  WebkitTextStroke: '1px #002C41',
  filter: 'drop-shadow(1px 0px 0 #002C41) drop-shadow(1px  0px 0 #002C41)',
  background: 'linear-gradient(180deg, #fff 0%,#7ADCF6 100%)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  display: 'inline-block'
};
